import { apiCall } from './config';

export default {
  createAccountPartner: payload => {
    const { email, role, loggedInUser, companyCode } = payload;

    return apiCall('v1/partnerportal/user', 'POST', {
      body: {
        cognitoId: email.substring(0, email.lastIndexOf('@')),
        email,
        role,
        loggedInUser,
        companyCode
      }
    });
  },
  getAllAccountsApi: payload =>
    apiCall('v1/partnerportal/user', 'GET', {
      queryString: payload
    }),
  updateAccountStatusApiCall: payload =>
    apiCall('v1/partnerportal/user', 'PATCH', {
      queryString: payload,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: {}
    }),

  fetchSampleCSVApiCall: () =>
    apiCall('v1/partnerportal/csv/sample', 'GET', {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      }
    }),
  deleteAccountApiCall: payload =>
    apiCall('v1/partnerportal/user', 'DEL', {
      queryString: payload
    }),
  fetchAccountsByPatternApi: payload => {
    const { pageNo, pageSize, pattern: searchPattern } = payload;
    return apiCall('v1/users/filter', 'GET', {
      queryString: {
        pageNo,
        pageSize,
        searchPattern
      }
    });
  },
  downloadCSVApiCall: payload => {
    const { fileName } = payload;
    return apiCall('v1/partnerportal/csv', 'GET', {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      queryString: {
        fileName
      }
    });
  },
  postCreateAccountsCSVFile: payload => {
    const { file, name } = payload;
    return apiCall('v1/partnerportal/csv', 'POST', {
      body: {
        fileData: file,
        fileName: name
      }
    });
  },
  getCSVHistory: () => apiCall('v1/partnerportal/csv/history', 'GET'),
  getRowIdResponse: payload =>
    apiCall('v1/partnerportal/csv/row', 'GET', { queryString: payload }),
  changeUserRole: payload => {
    const { cognitoId, targetRole } = payload;
    return apiCall(`v1/partnerportal/user/${cognitoId}`, 'PATCH', {
      body: {
        role: targetRole
      }
    });
  },
  resendEmail: payload =>
    apiCall(`v1/partnerportal/${payload}/email`, 'POST', {
      headers: {
        'Content-Type': 'application/json'
      },
      body: {}
    }),
  getAllAccountsCorporate: payload =>
    apiCall('v1/users/corporate/users/role-and-status', 'GET', {
      queryString: payload
    }),
  createAccountCorporate: payload => {
    const { email, role, loggedInUser, sites } = payload;
    return apiCall('v1/users', 'POST', {
      body: {
        cognitoId: email.substring(0, email.lastIndexOf('@')),
        email,
        role,
        loggedInUser,
        sites
      }
    });
  },
  changeSites: ({ userId, sites }) =>
    apiCall(`v1/user/${userId}`, 'PUT', {
      queryString: { targetSite: sites },
      body: {}
    }),
  profileEnable: () =>
    apiCall('v1/partnerportal/profile/enable', 'PUT', {
      headers: {
        'Content-Type': 'application/json'
      },
      body: {}
    }),
  getCompaniesList: () => apiCall('v1/partnerportal/partners', 'GET'),
  downloadPeopleFile: payload => {
    return apiCall('v1/partnerportal/users/download', 'GET', {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      queryString: {
        ...payload
      }
    });
  }
};
